const defaultSettings = {
  layout: {
    highContrast: false,
    blackWhite: false,
    reduceTransparency: false,
    reduceMotion: false,
  },

  text: {
    fontFamily: "Default",
    fontSize: 16,
    letterSpacing: 0,
    wordSpacing: 0,
  },
};

export default defaultSettings;